import React, { useState } from 'react';
import { IconButton, Drawer, Box, Tooltip, Button } from '@mui/material';
import { I18nextProvider, useTranslation } from 'react-i18next';
import processIcon from '../../assets/images/icon-process.svg';
import EndProcessDialog from './EndProcessDialog';
import CommentsIcon from '../../assets/images/icon-comments.svg';
import EventIcon from '../../assets/images/icon-events.svg';
import { CommentSidebar, EventManager, FreyrComponentLibraryProvider, LinkedRecordSidebar } from '@freyr/freyr-react-common-components';
import { useAppCookies } from '../../assets/utils';
import Cookies from 'js-cookie';
import Iframe from 'react-iframe';
import Loading from '../../components/Loading';
import CloseIcon from '@mui/icons-material/Close';
import { useDrawerContext } from '../../contexts/DrawerContext';
import LinkedRecordIcon from '../../assets/images/icon-linked-records.svg';
import style from "./index.module.scss";
import AuditReportDrawer from '../audit/AuditReportDrawer';
import AuditIcon from "../../assets/images/icon-audit.svg";
import { IdentifiersDialogs } from '../../components/IdentifierDialogs';
import { enqueueSnackbar } from 'notistack';
import i18n from '../../i18n';
import { getGlobalConfigStoreValues } from '../../assets/config';
import useIdentifiersDialogsStore from '../../hooks/useIdentifierDialogsStore';
import { useShallow } from 'zustand/react/shallow';
import IdentifiersIcon from '../../assets/images/icon-identifiers.svg';
import useMainStore from '../../store/main';
import { LinkedRecordQueryIdentifier } from '../../api/apiFunctions';



interface ProcessIconButtonProps {
  xevmpdId?: string;
  taskButtonConfig?: any;
  relatedProcessInfo?: {
    processAclOwner: boolean;
    currentTaskOwner: boolean;
    applicationEditable: boolean;
  };
  rows?: any[];
  mode?: string;
  params?: any;
  recordID?: string;
}
type IdentifierType = {
  field: string;
  value: (string | number)[];
};

export default function ProcessIconButton({
  xevmpdId,
  taskButtonConfig,
  relatedProcessInfo,
  rows = [],
  mode,
  params,
  recordID,
}: ProcessIconButtonProps) {

  const [openEndProcessDialog, setOpenEndProcessDialog] = useState(false);
  const { t } = useTranslation();
  const { token, tenantID,  cookies, userID,domain } = useAppCookies();
  const userEmail=Cookies.get("USER_EMAIL") || "";
  const [iframeLoading, setIframeLoading] = useState(true);
  const config = getGlobalConfigStoreValues();
  const language = config?.state?.language || 'en';
  
  
  // Use drawer context
  const { eventOpen, commentMessageOpen, processDrawerOpen, linkRecordSidebarOpen, setEventOpen, setCommentMessageOpen, setProcessDrawerOpen, setLinkRecordSidebarOpen,auditDrawerOpen,setAuditDrawerOpen  } = useDrawerContext();
   const { handleClickSingleIdentifier, closeSingleIdentifierPop, closeManageIdentifierPop, showSingleManageIdentifierPop } = useIdentifiersDialogsStore(useShallow(state => ({
    handleClickSingleIdentifier: state.handleClickSingleIdentifier,
    closeSingleIdentifierPop: state.closeSingleIdentifierPop,
    closeManageIdentifierPop: state.closeManageIdentifierPop,
    showSingleManageIdentifierPop: state.showSingleManageIdentifierPop
  })));
  const processAssociationId = taskButtonConfig?.processAssociationId;
  const [identifiers, setIdentifiers] = useState<IdentifierType[]>([]);
    const [reportDrawerList, setReportDrawerList] = useState([]);
    const [isEntityReport, setIsEntityReport] = useState(false);
    const { identifierMap } = useMainStore((state) => {
    return {
      identifierMap: state.identifierMap,
    };
  });
 
  console.log("relatedProcessInfo:", relatedProcessInfo,taskButtonConfig);

  const handleViewProcess = () => {
    if (processAssociationId) {
      setProcessDrawerOpen(!processDrawerOpen);
    }
  };

  const handleEndProcessConfirm = (comment: string) => {
    console.log('End process with comment:', comment);
    setOpenEndProcessDialog(false);
  };

  const handleEndProcessSuccess = () => {
    console.log('Process ended successfully');
  };

  const handleComments = () => {
    closeIdentifiersDialog();
    setCommentMessageOpen(!commentMessageOpen);
  }

  const handleOpenEvent = () => {
   closeIdentifiersDialog();
   setEventOpen(!eventOpen);
  }

  const handleCloseProcessDrawer = () => {
    setProcessDrawerOpen(false);
    setIframeLoading(true);
  };

  const handleCancel = () => {
    setAuditDrawerOpen(false);
  };

  const closeIdentifiersDialog = () => {
    closeSingleIdentifierPop();
    closeManageIdentifierPop();
    document.body.classList.remove('identifiers-dialog-open');
  };

  const openIdentifiersDialog = (id: string) => {
    document.body.classList.add('identifiers-dialog-open');
    handleClickSingleIdentifier(id,identifierMap,null);
  };

  const handleLinkedRecordClick =async () => {
   closeIdentifiersDialog();
    const response = await LinkedRecordQueryIdentifier({xevmpdIds: [xevmpdId]});
      let identifiersData: Record<string, string[]> = {};
      
        identifiersData = JSON.parse(
          response.data.data?.identifierJson ?? "{}"
        );
      
      const identifierList = Object.entries(identifiersData || {})
        .map(([field, value]) => ({ field, value: value || [] }))
        .filter((item) => item.value?.length > 0);
      setIdentifiers(identifierList);
  setLinkRecordSidebarOpen(!linkRecordSidebarOpen);
  document.body.classList.remove('identifiers-dialog-open');
};


  const origin = window.location.origin.replace('xevmpd.', 'PAT.');
  const IframeUrl = `${origin}/process/${processAssociationId}`;

  return (
    <>
      {/* Process Icon Button */}
      <Tooltip title="Events">
      <IconButton
        className="process-icon-position"
        title="Events"
        onClick={handleOpenEvent}
      >
        <img
          src={EventIcon}
          alt="Event Icon"
          style={{ width: "18px" }}
        />
      </IconButton>
      </Tooltip>
      <Tooltip title="Comments">
      <IconButton
        className="process-icon-position"
        title="Comments"
        onClick={handleComments}
      >
        <img
          src={CommentsIcon}
          alt="Comments Icon"
          style={{ width: "18px" }}
        />
      </IconButton>
      </Tooltip>
      <Tooltip title="View Process">
      <IconButton
        className="process-icon-position"
        title="View Process"
        disabled={!processAssociationId}
        onClick={handleViewProcess}
      >
        <img
          src={processIcon}
          alt="Process Icon"
          style={{ width: "18px", opacity: processAssociationId ? 1 : 0.4 }}        />
      </IconButton>
      </Tooltip>
     
      <Tooltip title="Audit">
        <IconButton
          className="auditlog-icon-position"
          title="Audit"
          onClick={() => {
            setAuditDrawerOpen(!auditDrawerOpen);
            closeIdentifiersDialog();
          }}
        >
                      <img
                        src={AuditIcon}
                        alt="Audit Icon"  
                        // style={{ width: "18px" }}
                      />
                    </IconButton>
                    </Tooltip>
                    <Tooltip title={t("Identifiers")}>
            <IconButton onClick={() => {
              if (showSingleManageIdentifierPop) {
                closeIdentifiersDialog();
              } else {
                setEventOpen(false);
                setProcessDrawerOpen(false);
                setCommentMessageOpen(false);
                setLinkRecordSidebarOpen(false);
                setAuditDrawerOpen(false);
                openIdentifiersDialog(xevmpdId!);
              }
            }}>
              <img src={IdentifiersIcon} alt={t("identifiers_tooltip")} style={{ width: "18px" }} />
            </IconButton>
          </Tooltip>
                     <IconButton className={style["side-icon-button"]} onClick={handleLinkedRecordClick}>
        <Tooltip title={t("common.linkRecord")}>
          <img src={LinkedRecordIcon} alt="" style={{ width: "18px" }} />
        </Tooltip>
      </IconButton>
                   
      {/* View Process Drawer */}
      <Drawer
        anchor="right"
        open={processDrawerOpen}
        onClose={handleCloseProcessDrawer}
        ModalProps={{
          BackdropProps: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.2)", // Very transparent backdrop
              WebkitBackdropFilter: "blur(5px)",
            },
          },
          keepMounted: false,
          sx: {
            // This ensures the drawer content respects the margin
            marginTop: "35px",
            height: "calc(100vh - 25px)",
          }
        }}
        SlideProps={{
          style: {
            marginTop: "40px",
            height: "calc(100vh - 40px)",
          }
        }}
      >
        <Box sx={{ 
          height: "100%", 
          width: "100%",
          overflow: 'hidden',
        }}>
          {/* Header with close button */}
                    <div className="slidebar_header" style={{ display: 'flex', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid #e0e0e0' }}>
            <h5 style={{ flexGrow: 1, margin: 0 }}>{t("workflow.viewProcess")}</h5>
           
            <CloseIcon
              onClick={() => {
                setProcessDrawerOpen(false);
              }}
              className="close icon-close-round mr-40"
            ></CloseIcon>
          </div>
          

          {/* Iframe content */}
          <Box sx={{ 
            height: "calc(100% - 73px)", // Adjusted for header height
            width: "100%", 
            p: 2,
            background: "transparent",
          }}>
            {iframeLoading && (
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100%',
                // background: "rgba(255, 255, 255, 0.5)",
                // backdropFilter: "blur(5px)",
                borderRadius: "8px",
              }}>
                <Loading open={iframeLoading} />
              </Box>
            )}
            <Iframe
              url={IframeUrl}
              width="100%"
              height="100%"
              id="process-view-iframe"
              display="block"
              position="relative"
              onLoad={() => setIframeLoading(false)}
              styles={{
                border: "none",
                borderRadius: "8px",
                opacity: iframeLoading ? 0 : 1,
                transition: 'opacity 0.3s ease-in-out',
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
              }}
            />
          </Box>
        </Box>
      </Drawer>

      {/* End Process Dialog */}
      <EndProcessDialog
        open={openEndProcessDialog}
        onClose={() => setOpenEndProcessDialog(false)}
        onEndProcess={handleEndProcessConfirm}
        recordId={xevmpdId || ""}
        onSuccess={handleEndProcessSuccess}
      />
      
      <FreyrComponentLibraryProvider
        token={token}
        language={"en"}
        tenant={String(tenantID)}
        domain={"1"}
        domainName={cookies.DOMAIN}
        useEmail={userEmail}
        moduleName="xEVMPD"
        envVars={{ 
          IM_PREFIX: process.env.REACT_APP_API_GETWAY,
          URF_PREFIX: process.env.REACT_APP_API_GETWAY 
        }}
      >
        <EventManager
          moduleId={35}
          userId={userID}
          primaryBusinessObjectTypeId="xevmpd"
          primaryBusinessObjectId={recordID!}
          open={eventOpen}
          onClose={() => setEventOpen(false)}
          width={"50%"}
          height="calc(100vh - 40px)"
          paperProps={{
            sx: { 
              height: "calc(100vh - 40px)",
              top: "40px",
            },
          }}
        />
        <CommentSidebar
          open={commentMessageOpen}
          onClose={() => {
            setCommentMessageOpen(false);
          }}
          recordId={"xEVMPD-" + xevmpdId}
          marginTop="40px"
          dataFormat="DD MMM YYYY, h:mm a"
          width={"50%"}
        />
         <LinkedRecordSidebar
        marginTop="40px"
        open={linkRecordSidebarOpen}
        onClose={() => setLinkRecordSidebarOpen(false)}
        identifiers={identifiers}
        recordId={"xEVMPD-" + xevmpdId}
        requestModule="xevmpd"
      />
      </FreyrComponentLibraryProvider>
      <I18nextProvider i18n={i18n}>
        <FreyrComponentLibraryProvider
          token={token}
          language={language!}
          tenant={String(tenantID)}
          domain={"1"}
          domainName={domain}
          useEmail={userEmail}
          moduleName="xEVMPD"
          envVars={{ IM_PREFIX: process.env.REACT_APP_API_GETWAY }}>
          <IdentifiersDialogs openSnackbar={enqueueSnackbar}/>
        </FreyrComponentLibraryProvider>
      </I18nextProvider>
      {auditDrawerOpen && (
              <AuditReportDrawer
                identifierData={identifiers}
                openAddPopup={auditDrawerOpen}
                handleCancel={handleCancel}
                reportDrawerList={reportDrawerList}
                isEntity={isEntityReport}
                setIsEntityReport={setIsEntityReport}
                setReportDrawerList={setReportDrawerList}
                setIdentifierData={setIdentifiers}
                setOpenAddPopup={setAuditDrawerOpen}
                recordId={recordID}
                xevmpdId={xevmpdId}
              />
            )}
    </>
  );
}